export default {
    header: {},
    heading: {},
    headingPack: {},
    content: {},
    bedIcon: {},
    options: {},
    hide: {},
    optionsDelete: {},
    editIcon: {},
    listHabi: {},
    noRibbon: {},
    displayBlock: {},
    tooltipHelp: {},
    tooltipHelpClose: {},
    selected: {},
    tooltipHelpCloseContainer: {},
    priceCompare: {
        '@media (min-width:540px)': {
            marginBottom: '30px'
        }
    },
    defaultStyle: {
        maxWidth: '1170px',
        margin: '0 auto',
        '& $header': {
            //backgroundColor: '#fff',
            //WebkitFilter: 'drop-shadow(3px 1px 3px rgba(0, 0, 0, 0.3))',
            //filter: 'drop-shadow(3px 1px 3px rgba(0, 0, 0, 0.3))',
            border: '1px solid #d8d8d8',
            position: 'relative',
            minHeight: '60px',
            margin: '0 0 13px',
            '& $heading': {
                borderRight: '1px solid #d8d8d8',
                width: '50px',
                textAlign: 'center',
                position: 'absolute',
                padding: '18px 5px 0',
                left: '0',
                top: '0',
                bottom: '0',
                boxSizing: 'content-box',
                '& $headingPack': {
                    '& span': {
                        fontSize: '11px',
                        '&:lang(ar)': {
                            float: 'right'
                        }
                    },
                    '& span:first-of-type': {
                        fontSize: '23px',
                        '&:lang(ar)': {
                            float: 'right'
                        }
                    },
                    '@media (min-width: 801px)': {
                        '& span': {
                            fontSize: '18px'
                        },
                        '& span:first-of-type': {
                            fontSize: '36px'
                        }
                    },
                    '&:lang(ar)': {
                        overflow: 'hidden'
                    }
                },
                '@media (min-width: 801px)': {
                    padding: '24px 10px 0',
                    width: '69px'
                },
                /*'&:after': {
                    content: "''",
                    left: '50%',
                    top: '100%',
                    borderLeft: '5px solid transparent',
                    borderRight: '5px solid transparent',
                    borderTop: '7px solid',
                    borderTopColor: data => data.mainColor,
                    position: 'absolute',
                    marginLeft: '-5px',
                    "&:lang(ar)": {
                        right: "50%",
                        marginLeft: "0",
                        marginRight: "-5px"
                    }
                },*/
                "&:lang(ar)": {
                    borderRight: "none",
                    borderLeft: "1px solid #d8d8d8",
                    left: "auto",
                    right: "0"
                }
            },
            '& $content': {
                padding: '10px 10px 10px 70px',
                position: 'relative',
                "&:lang(ar)": {
                    paddingLeft: "10px",
                    paddingRight: "70px",
                    '@media (min-width:801px)': {
                        paddingLeft: "20px",
                        paddingRight: "116px"
                    }
                },
                '@media (min-width:801px)': {
                    padding: '14px 20px 18px 116px',
                    fontSize: '24px'
                },
                '& $bedIcon': {
                    color: data => data.mainColor,
                    '@media (min-width:801px)': {
                        font: '32px/1px Icons',
                        position: 'absolute',
                        left: '0',
                        top: '50%'
                    },
                    "&:lang(ar)": {
                        left: "auto",
                        right: "0"
                    }
                }
            },
            '@media (min-width:801px)': {
                margin: '0 0 30px'
            },
            '& $options': {
                position: 'absolute',
                top: '0',
                right: '0',
                bottom: '0',
                width: '60px',
                "&:lang(ar)": {
                    right: "auto",
                    left: "0"
                },
                '@media (min-width:801px)': {
                    width: '100px'
                }
            },
            '& $priceCompare':{
                '@media (min-width:540px)': {
                    marginBottom: '30px'
                }
            },
            '& $hide': {
                position: 'absolute',
                bottom: '15px',
                right: '55px',
                '@media (min-width:801px)': {
                    height: '24px',
                    width: '100px',
                    bottom: '50%',
                    marginBottom: '-12px'
                },
                '&:lang(ru)': {
                    right: '100px'
                },
                '&:lang(bg)': {
                    right: '100px'
                },
                "&:lang(ar)": {
                    right: "auto",
                    left: "55px"
                }
            },
            '& $optionsDelete': {
                position: 'absolute',
                bottom: '15px',
                right: '15px',
                '@media (min-width:801px)': {
                    height: '24px',
                    width: '24px',
                    bottom: '50%',
                    marginBottom: '-12px'
                },
                "&:lang(ar)": {
                    right: "auto",
                    left: "15px"
                }
            },
            '& $editIcon': {
                position: 'absolute',
                right: '35px',
                height: '15px',
                width: '15px',
                bottom: '50%',
                marginBottom: '-8px',
                '@media (min-width:801px)': {
                    fontSize: '16px',
                    display: 'block',
                    right: '71px',
                    bottom: '50%',
                    marginBottom: '-12px'
                },
                "&:lang(ar)": {
                    right: "auto",
                    left: "35px",
                    "@media (min-width: 801px)": {
                        right: "auto",
                        left: "71px"
                    }
                }
            },
            '& $hideEdit': {
                display: 'none'
            }
        },
        '& $listHabi': {
            '@media (min-width:801px)': {
                maxWidth: '1180px',
                margin: '0 auto 50px',
                paddingTop: '30px',
            },

            '&:last-of-type': {
                marginBottom: '0px',

                '& > div:first-of-type': {
                    marginBottom: '0px'
                }
            }
        },
        '& $noRibbon': {
            '& $heading': {
                paddingTop: '10px'
            }
        },
        '& > ul': {
            listStyle: 'none',
            margin: '0',
            padding: '0',
        },
        '&$selected': {
            '& $header': {
                '& $heading': {
                    background: '#5ca70a',
                    color: '#fff',
                    padding: '10px 5px 14px',
                    WebkitTransition: '0.3s',
                    OTransition: '0.3s',
                    MsTransition: '0.3s',
                    MozTransition: '0.3s',
                    transition: '0.3s',
                    '&:after': {
                        borderTopColor: '#5ca70a',
                        WebkitTransition: 'border-top-color 0.3s',
                        OTransition: 'border-top-color 0.3s',
                        MsTransition: 'border-top-color 0.3s',
                        MozTransition: 'border-top-color 0.3s',
                        transition: 'border-top-color 0.3s'
                    },
                    '@media (min-width:801px)': {
                        width: '69px',
                        padding: '24px 10px 0',
                        background: '#5ca70a',
                        color: '#fff',
                        '&:after': {
                            display: 'none'
                        }
                    }
                },
                '& ul': {
                    '& $hide': {
                        display: 'none'
                    },
                    '& $displayBlock': {
                        display: 'block'
                    }
                }
            }
        },
        '&:lang(ar)': {
            direction: 'rtl',
            textAlign: 'right'
        }
    },
    hideEdit: {
        display: 'none'
    },
    warning: {
        "&:lang(ar)": {
            left: "auto",
            right: "0"
        },
        font: '18px/1px Icons',
        position: 'absolute',
        left: '0',
        top: '50%'
    },
    '& > ul': {
        listStyle: 'none',
        margin: '0',
        padding: '0',
        '@media (min-width:801px)': {
            paddingTop: '30px'
        }
    },
    '& $displayBlock': {
        '@media (min-width:801px)': {
            padding: '20px 0 0'
        }
    },
    hotelSelection: {
        padding: '0'
    },
    tooltipHelpContainer: {
        position: 'relative',
        marginTop: '10px',
        '& $tooltipHelp': {
            position: 'absolute',
            top: '-52px',
            left: '0',
            right: '0',
            background: '#fc0',
            textAlign: 'center',
            WebkitTransition: '0.3s',
            OTransition: '0.3s',
            MsTransition: '0.3s',
            MozTransition: '0.3s',
            transition: '0.3s',
            padding: '10px 20px 10px 10px',
            marginBottom: '15px',
            zIndex: '2',
            "&:lang(ar)": {
                paddingRight: "10px",
                paddingLeft: "20px",
                "&:after": {
                    left: "auto",
                    right: "12px"
                },
                '@media (min-width:801px)': {
                    left: "auto"
                }
            },
            '@media (min-width:801px)': {
                right: 'auto',
                width: '300px'
            },
            '&:after': {
                content: "''",
                left: '12px',
                borderLeft: '9px solid transparent',
                borderRight: '9px solid transparent',
                borderTop: '10px solid #fc0',
                position: 'absolute',
                top: '100%'
            },
            '& $tooltipHelpCloseContainer': {
                "&:lang(ar)": {
                    position: "relative"
                },
                position: 'relative',
                '& $tooltipHelpClose': {
                    "&:lang(ar)": {
                        left: '-12px',
                        right: "auto"
                    },
                    position: 'absolute',
                    top: '-5px',
                    right: '-12px'
                }
            }
        },
        '@media (min-width:801px)': {
            marginTop: '50px'
        }
    },
    noDispoButtonContainer: {
        textAlign: 'center',
        paddingTop: '35px',
        paddingBottom: '20px',
        '& > button': {
            boxSizing: 'border-box',
            fontFamily: 'Roboto',
        },
        '@media(max-width:900px)': {
            '& > button': {
                '&:hover':{
                    background:'transparent!important',
                    '& span':{
                        color:data => [data.mainColor,'!important']
                    }
                },
                '&:focus':{
                    background:'transparent!important',
                    '& span':{
                        color:data => [data.mainColor,'!important']
                    }
                }
            },  
        },
        '@media(min-width:801px)': {
            maxWidth: '400px',
            margin: '0 auto'
        }
    },
    closeIcon: {
        verticalAlign: 'baseline',
    },
    hasFilters:{}
}
